import { uniqBy } from "lodash";
import { sale } from "../typings/sale";
import { item } from "../typings/item";

export class AbsenteeBidsService {
    public static $inject: string[] = [
        "$http",
        "$log",
        "configService"
    ];

    public saleAbsenteeBidsSuccess: sale.AbsenteeBidData[] = [];
    public saleAbsenteeBidsError: sale.AbsenteeBidError[] = [];
    public isLoadingSaleAbsenteeBids: boolean;
    public itemsAbsenteeBidsSuccess: item.AbsenteeBidData[] = [];
    public isLoadingItemAbsenteeBids: boolean;
    private gatewayConfig;
    private userConfig;

    constructor(
        private $http: ng.IHttpService,
        private $log: ng.ILogService,
        configService
    ) {
        this.gatewayConfig = configService.gatewayApi;
        this.userConfig = configService.userApi;
    }

    public getAbsenteeBidsCountForSales(saleIds: number[]) {
        if (saleIds.length) {
            this.isLoadingSaleAbsenteeBids = true;
            this.$http.get(`${ this.gatewayConfig.url }/v1/users/absentee_bids`, {
                params: {
                    sale_ids: saleIds.toString()
                }
            })
            .then((saleAbsenteeBidsResult: any) => {
                this.saleAbsenteeBidsSuccess = uniqBy(
                    [...saleAbsenteeBidsResult.data.data, ...this.saleAbsenteeBidsSuccess],
                    "sale_id"
                );
                this.saleAbsenteeBidsError = uniqBy(
                    [...saleAbsenteeBidsResult.data.errors, ...this.saleAbsenteeBidsError],
                    "sale_id"
                );
                this.isLoadingSaleAbsenteeBids = false;
            })
            .catch(error => {
                this.$log.error("Error while fetching sales absentee bids ", error);
                this.isLoadingSaleAbsenteeBids = false;
            });
        }
    }

    public getAbsenteeBidsCountForItems(saleId: number) {
        if (saleId) {
            this.isLoadingItemAbsenteeBids = true;
            this.$http.get(`${ this.userConfig.url }/v1/sales/${saleId}/absentee-bids-count-by-item`)
                .then((itemsAbsenteeBidsSuccess: any) => {
                    this.itemsAbsenteeBidsSuccess = itemsAbsenteeBidsSuccess.data;
                    this.isLoadingItemAbsenteeBids = false;
                })
                .catch(error => {
                    this.$log.error("Error while fetching items absentee bids ", error);
                    this.isLoadingItemAbsenteeBids = false;
                });
        }
    }

    public getAbsenteeBidsCountForSale(saleId: number): sale.AbsenteeBidData | sale.AbsenteeBidError {
        return this.saleAbsenteeBidsSuccess.find(absenteeBid => absenteeBid.sale_id === Number(saleId))
        || { ...this.saleAbsenteeBidsError.find(absenteeBid => absenteeBid.sale_id === Number(saleId)), error: true };
    }

    public getAbsenteeBidsCountForItem(itemId: number): item.AbsenteeBidData {
        return this.itemsAbsenteeBidsSuccess.find(absenteeBid => absenteeBid.item_id === Number(itemId));
    }
}
